import styled from 'styled-components';

export const FormListContentWrapper = styled.div<{ isEdit: boolean }>`
  display: flex;
  flex-direction: column;

  & > div > div {
    margin-right: ${({ isEdit }) => (isEdit ? '50px' : 0)};
    &:last-child {
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }

  ${({ isEdit }) =>
    isEdit &&
    `
    & > div:first-child {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      max-height: 500px;
    }
  `}
`;

export const FormItemWrapper = styled.div<{ isLast: boolean; isBtn: boolean }>`
  display: flex;

  & > div:first-child {
    display: flex;
    width: 100%;
    flex-direction: column;

    & > div:last-child {
      align-self: ${({ isBtn }) => (isBtn ? 'flex-end' : 'none')};

      .ant-btn {
        padding: 0;
      }
    }
  }

  ${({ isLast }) =>
    isLast &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        align-self: flex-start;
        margin-top: 33px;
    }
  `}
`;

export const FormWrapper = styled.div<{ isEdit: boolean }>`
  ${({ isEdit }) =>
    isEdit &&
    `
    .ant-form-item {
      width: 288px;
    }
  `}
`;
